var parse = require('./parse')
var stringify = require('./stringify')

module.exports = parse
module.exports.parse = parse
module.exports.stringify = stringify



//////////////////
// WEBPACK FOOTER
// ./node_modules/protocol-buffers-schema/index.js
// module id = 772
// module chunks = 0